<template>
  <div class="text-center mt-5">
    <div v-if="data.last_page > 1" class="inline-flex border rounded">
      <button type="button" class="py-2 px-3 rounded-l bg-grey-lighter" :class="{'opacity-50 cursor-not-allowed': data.current_page === 1, 'hover:bg-grey-light': data.current_page !== 1}" @click="goToPage(1)">
        <i class="fas fa-angle-double-left" />
      </button>
      <button type="button" class="py-2 px-3 bg-grey-lighter border-l" :class="{'opacity-50 cursor-not-allowed': data.current_page === 1, 'hover:bg-grey-light': data.current_page !== 1}" @click="goToPage(data.current_page - 1)">
        <i class="fas fa-angle-left" />
      </button>

      <button v-for="i in data.last_page" :key="i" v-if="i >= data.current_page-3 && i <= data.current_page+3" type="button" class="py-2 px-3 border-l" :class="{'bg-tertiary text-white cursor-not-allowed': data.current_page === i, 'bg-grey-lighter': data.current_page !== i, 'hover:bg-grey-light': data.current_page !== i}" @click="goToPage(i)">
        {{ i }}
      </button>

      <button type="button" class="py-2 px-3 bg-grey-lighter border-l" :class="{'opacity-50 cursor-not-allowed': data.current_page === data.last_page, 'hover:bg-grey-light': data.current_page !== data.last_page}" @click="goToPage(data.current_page + 1)">
        <i class="fas fa-angle-right" />
      </button>
      <button type="button" class="py-2 px-4 rounded-r bg-grey-lighter border-l" :class="{'opacity-50 cursor-not-allowed': data.current_page === data.last_page, 'hover:bg-grey-light': data.current_page !== data.last_page}" @click="goToPage(data.last_page)">
        <i class="fas fa-angle-double-right" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paginator',

  props: {
    data: Object
  },
  methods: {
    goToPage (i) {
      if (this.data.current_page === i || i < 1 || i > this.data.last_page) {
        return
      }

      this.$emit('change', i)
    }
  }
}
</script>
